<template>
    <div class="form-group col-12 ">
        <div class="col-12 text-left striped-sm">
            <div class="d-inline d-lg-block mr-2 mt-4 labelNovaOs">Descrição:</div>
            <div class="row">
                <div class="col-12 col-sm-12 col-lg-12 mb-2">
                    <input class="form-control" type="text" v-model="form.descricao">
                </div>
            </div>
        </div>
        <div class="col-12 text-left striped-sm">
            <div class="d-inline d-lg-block mr-2 mt-4 labelNovaOs">Segmento:</div>
            <div class="row">
                <div class="col-12 col-sm-12 col-lg-12 mb-2">
                    <v-select :options="grupos" v-model="form.segmento">
                    </v-select>
                </div>
            </div>
        </div>
        <div class="col-12 text-left striped-sm">
            <div class="d-inline d-lg-block mr-2 mt-4 labelNovaOs">Criticidade:</div>
            <div class="row">
                <div class="col-12 col-sm-12 col-lg-12 mb-2">
                    <v-select :options="criticidade" v-model="form.criticidade">
                    </v-select>
                </div>
            </div>
        </div>
        <div class="col-12 text-left striped-sm">
            <div class="d-inline d-lg-block mr-2 mt-4 labelNovaOs">SLA:</div>
            <div class="row">
                <div class="col-12 col-sm-12 col-lg-12 mb-2">
                    <input class="form-control" type="text" v-model="form.sla">
                </div>
            </div>
        </div>
        <div class="col-12 text-left striped-sm">
            <div class="d-inline d-lg-block mr-2 mt-4 labelNovaOs">Status:</div>
            <div class="row">
                <div class="col-12 col-sm-12 col-lg-12 mb-2">
                    <select class="form-control" v-model="form.status">
                        <option value="I">Não</option>
                        <option value="A">Sim</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="card-footer mt-4">
            <button type="button" class="btn btn-success mr-3" @click="enviarForm">Salvar</button>
            <button type="button" class="btn btn-info mr-3">Novo</button>
            <router-link to="/" class="btn btn-danger mr-2">
                <i class="fas fa-close"></i>
                Cancelar
            </router-link>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
export default {
    name: 'NovaOsComponent',
    data() {
        return {
            form: {
                descricao: '',
                segmento: {},
                criticidade: {},
                sla: '',
                status: '',
            }
        }
    },

    props: {
        editMode: {},
        findSegmento: {}
    },

    created() {
        this.$store.dispatch('os/fetchMediaLiberacao', { st_origem: 'E', filial: 2 })
    },

    computed: {
        grupos() {
            const grupos = this.$store.getters['frotaConjunto/grupos']

            if (!grupos) {
                this.$store.dispatch('frotaConjunto/getGrupos', { operacao: 0 })
                return []
            }

            return grupos.map(grupo => {
                return {
                    ...grupo,
                    label: grupo.ds_grupo
                }
            })
        },

        criticidade() {
            const media = this.$store.getters['os/mediaLiberacao']

            if (!media) {
                this.$store.dispatch('os/fetchMediaLiberacao', { st_origem: 'E', filial: 2 })
                return []
            }

            return media.map(grupo => {
                return {
                    ...grupo,
                    label: grupo.ds_criticidade
                }
            })
        }
    },

    watch: {
        editMode(newValue, oldValue) {
        },

        findSegmento() {
            this.popularCampos()
        }
    },

    methods: {
        popularCampos() {
            console.log(this.findSegmento)
            this.form.descricao = this.findSegmento.ds_conjunto
            this.form.segmento = this.findSegmento.ds_grupo
            this.form.criticidade = this.findSegmento.ds_criticidade
            this.form.sla = this.findSegmento.hr_sla
            this.form.stats = this.findSegmento.st_status
        },

        enviarForm() {
            if (this.editMode) {
                console.log(this.form)
            } else {
                this.$store.dispatch('os/salvarSegmento', { data: this.form }).then(response => {
                    this.form = {}
                    this.$swal.fire({
                        title: 'Sucesso!',
                        text: 'Sucesso ao cadastrar um segmento!',
                        icon: 'success',
                        time: 1000
                    })
                }).catch((error) => {
                    console.log(error)
                })
            }
        }
    }
}
</script>

<style scoped></style>
